<template>
<section id="footer" class="section footer appear" style="padding:0 0 60px 0;">
    <div class="container pad-bot40" style="position: relative;overflow: visible;">
    	<!--<img src="img/me.jpg" class="me col-sm-offset-2 img-responsive" draggable="false" style="position: absolute;top:-80px;border-radius: 50%;width:140px;height:140px;border: white 5px solid;">-->
        <div class="row align-center copyright" style="text-align: left;margin-top: 80px;">
            <div class="col-sm-5 col-sm-offset-2">
            	<p style="font-size: 36px;">联系我</p>
            	<br>
                <p>邮箱： minholl@qq.com</p>
                <p>简书： 简子逍</p>
                <p>公众号： 四元群</p>
                <br>
                <p>欢迎大家关注我的个人微信公众号，不定期分享生活趣事、技术文献、学习资料等。 (>‿◠)✌</p>
                <p>请不要忘记，那给你带来感动的，名为二次元的理想乡。</p>
                <br>
                <p>
                    <small><a href="http://www.beian.miit.gov.cn/" target="_blank" class="color-footer"><i class="fa fa-shield"></i>&nbsp;&nbsp;浙ICP备19044792号</a></small>
                    <br>
                    <small><a class="color-footer">浙公网安备 33010902002307号</a></small>
                    <!-- <small><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010902002307" target="_blank" class="color-footer">浙公网安备 33010902002307号</a></small> -->
                </p>
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <p class="mar-top100" style="font-size: 20px;"><i class="fa fa-weixin"></i>&nbsp;&nbsp;微信公众号</p>

                <p>
                	 <img src="../assets/img/qrcode.jpg" class="img-responsive" width="160" height="160">
                </p>
            </div>
        </div>
    </div>
</section>
</template>

<style>

</style>

<script>
export default {
  name: 'Footer'
}
</script>